import React, {useEffect, useState} from "react";
import mrbgS2S from "../mrbgLib/mrbgS2S.js";
import {mrbgStore} from "./mrbg/mrbgRedux/index.js";
import {useParams} from 'react-router-dom';
import {Navigate} from "../../.vite/deps/react-router-dom.js";
import Slider from "./Slider.jsx";
import Menu from "./Menu.jsx";
import BlogH1Frame from "./BlogH1Frame.jsx";
import BlogArea from "./BlogArea.jsx";
import MrbgLoader from "./mrbg/MrbgLoader.jsx";
import BlogContent from "./BlogContent.jsx";
import OurTeam from "./OurTeam.jsx";
import WorkWithUsForm from "./WorkWithUsForm.jsx";
import ContactUsForm from "./ContactUsForm.jsx";
import Footer from "./Footer.jsx";
import mainStyle from "../static/css/B_main.module.css";

function PagesBlog(){

  const
    {lang,pagePath} = useParams(),
    [mrbgVars,setMrbgVars] = useState(mrbgStore.getState().mrbgVars);

  function parallax(){
    document.querySelectorAll(`.${mainStyle.prl_Y}`).forEach(elm=>{
      if( elm.getBoundingClientRect().top < window.innerHeight+200)
        elm.classList.remove(mainStyle.prl_Y)
    })
  }

  useEffect(()=>{},[lang,pagePath,mrbgVars])
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setMrbgVars( mrbgStore.getState().mrbgVars );
    });
    window.addEventListener('scroll',parallax)
    setTimeout(()=>{
      window.dispatchEvent(new Event('scroll'));
    },500)
    return ()=> {
      window.removeEventListener('scroll', parallax)
      unsubscribe();
    }
  },[])

  if( mrbgVars.pageInfo===undefined ){
    mrbgS2S( null, null, 'pag','load' );
    return <MrbgLoader />
  }
  else if( mrbgVars.urlPath==404 ){
    return <Opps404 />
  }
  else if( '/'+mrbgVars.urlPath!==decodeURI(window.location.pathname) ){
    return <Navigate replace to={`/${mrbgVars.urlPath}`}/>
  }
  else{

    document.title = mrbgVars.pageInfo.title;
    document.querySelector('meta[name="description"]').content = mrbgVars.pageInfo.description;
    document.documentElement.setAttribute( 'lang', mrbgVars.lang )

    return(
      <>
        { mrbgVars.slider?.length? <Slider {...{mainStyle}}/>: '' }
        <main id={mainStyle.blogMain}>
          <Menu {...{mainStyle}}/>
          { mrbgVars.pageInfo.h1? <BlogH1Frame {...{ mainStyle }}/>: '' }
          { mrbgVars.pageInfo.areaTitle? <BlogArea {...{mainStyle}}/>: '' }
          <BlogContent {...{mainStyle}}/>
          { mrbgVars.ourTeam?.length? <OurTeam {...{mainStyle}}/>: ''}
          { mrbgVars.pageInfo.contactUs? <ContactUsForm {...{mainStyle}}/>: '' }
          { mrbgVars.pageInfo.workWithUs? <WorkWithUsForm {...{mainStyle}}/>: '' }
          <Footer  {...{mainStyle}}/>
        </main>
        <MrbgLoader />
      </>
    )
  }
}
export default PagesBlog;